var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-page"},[_c('simple-header',{attrs:{"title":"Noti"}}),_vm._v(" "),_c('page-content',[_c('div',{staticClass:"content-padded"},[_c('p',[_vm._v("V0.1.1 has been released @2016/10/23 [changelog](https://github.com/vum-team/vum/blob/master/changelog.md)")]),_vm._v(" "),_c('p',[_vm._v("V0.1.0 should be released before 08/31")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.5.0@vue-loader/lib/template-compiler?{"id":"data-v-e42c3278","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.5.0@vue-loader/lib/selector.js?type=template&index=0!./src/demos/Noti.vue
// module id = null
// module chunks = 